/**
 * Read a clinic configuration flag from localStorage user.activeClinic.configuration.
 */
export const isClinicModuleEnabled = (code: string): boolean => {
  try {
    const raw = window.localStorage.getItem("user");
    if (!raw) return false;
    const user = JSON.parse(raw);
    const config = user?.activeClinic?.configuration?.find(
      (item: any) => item.code === code
    );
    const value = config?.value;
    return (
      value === true ||
      value === "true" ||
      value === 1 ||
      value === "1" ||
      value === "yes"
    );
  } catch {
    return false;
  }
};

export const isIpdModuleEnabled = (): boolean =>
  isClinicModuleEnabled("ipd_module");

export const isPharmacyModuleEnabled = (): boolean =>
  isClinicModuleEnabled("pharmacy_module");

export const isPathologyModuleEnabled = (): boolean =>
  isClinicModuleEnabled("pathology_module");
export const getClinicConfigurationItem = (code: string): any | null => {
  try {
    const raw = window.localStorage.getItem("user");
    if (!raw) return null;
    const user = JSON.parse(raw);
    return (
      user?.activeClinic?.configuration?.find(
        (item: any) => item.code === code
      ) ?? null
    );
  } catch {
    return null;
  }
};